import React from 'react';
import type { AppAuthShape } from './context';

function createShim(): AppAuthShape {
  return {
    isAuthenticated: false,
    isLoading: false,
    user: undefined,
    getAccessTokenSilently: async (_options?) => '',
    loginWithRedirect: async () => {},
    logout: async () => {},
  };
}

export function useAuth0Shim(): AppAuthShape {
  return createShim();
}

export function withAuthenticationRequiredShim<TProps>(
  Component: React.ComponentType<TProps>,
  _options?: unknown
) {
  return function Wrapped(props: TProps) {
    return React.createElement(
      Component as unknown as React.ComponentType<unknown>,
      props as unknown as Record<string, unknown>
    ) as React.ReactElement;
  };
}
